import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { forwardRef } from '@wordpress/element';
/**
 * Internal dependencies
 */

import PanelHeader from './header';

function Panel(_ref, ref) {
  var header = _ref.header,
      className = _ref.className,
      children = _ref.children;
  var classNames = classnames(className, 'components-panel');
  return createElement("div", {
    className: classNames,
    ref: ref
  }, header && createElement(PanelHeader, {
    label: header
  }), children);
}

export default forwardRef(Panel);
//# sourceMappingURL=index.js.map